module.exports = __webpack_public_path__ + "sky.66e78b37.png";


//////////////////
// WEBPACK FOOTER
// ./client/containers/App/sky.png
// module id = 641
// module chunks = 0